import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "Calculatrice du carré du nombre - Calcul du carré des nombres avec précision et rapidité";
const DESCRIPTION =
  "Calculatrice du carré du nombre - Calcul du carré des nombres avec précision et rapidité pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "du carré du nombre calcul du carré des nombres avec précision et rapidité, calculatrice du carré du nombre calcul du carré des nombres avec précision et rapidité, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/squared-calculator";
const SquaredCalculator = () => {
  const [number, setNumber] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!number) {
        throw new Error("Veuillez entrer un nombre.");
      }
      const num = parseFloat(number);
      if (isNaN(num)) throw new Error("Veuillez entrer un nombre correct.");
      const res = number * number;
      setResult(res);
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Utilisez cet outil avancé pour calculer le carré des nombres avec précision et rapidité. Que vous ayez besoin de calculer le carré d'un nombre entier ou d'un nombre décimal, la calculatrice vous fournit des résultats précis instantanément. Cet outil est idéal pour les étudiants, les enseignants et les ingénieurs, car il contribue à résoudre les problèmes mathématiques complexes, vérifier les zones et les volumes en géométrie, et simplifier les équations algébriques. Grâce à son interface intuitive et sa facilité d'utilisation, l'outil prend en charge une variété de nombres, ce qui en fait un excellent choix pour répondre à vos besoins éducatifs et professionnels en mathématiques.
                </p>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div className="ltr">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label me-2">Entrez le nombre</label>
                      </b>
                      <input
                        type="text"
                        placeholder="Exemple : 12"
                        value={number}
                        onChange={(e) => setNumber(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  <div>
                    { error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-dark">
                        Erreur : {error}
                      </p>
                    ) : null}
                    {result !== null && (
                      <div>
                        <p className="p-3 mb-2 bg-success text-white">
                          {number}² = {result}
                        </p>
                      </div>
                    )}
                  </div>
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Le carré d'un nombre</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Le carré d'un nombre est une opération mathématique qui consiste
                        à multiplier ce nombre par lui-même pour obtenir son carré.
                        Par exemple, le carré du nombre 5 est 5 × 5 = 25.
                        En général, le carré d'un nombre est noté en élevant ce nombre
                        à la puissance 2, comme 5², ce qui signifie 5 multiplié par 5.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
};
export default SquaredCalculator;
